import styled from "styled-components";

const StyledPlacesContainer = styled.div`
    margin-top: 1rem;
    display: none;
    flex-direction: column;
    align-items: flex-start;
    background-color: ${(props) => props.color1};
    color: ${(props) => props.color2};
    border: solid 1px ${({ theme }) => theme.colors.gray2};
    padding: 0.5rem;
    position: absolute;
    z-index: 999;
    width: 100%;
    border-radius: 0 0 3px 3px;
    
    &.active {
        display: flex;
    }
    
    .location-wrap {
        position: relative;
    }
    .suggestion-item {
        padding: 0.3rem;
        text-align: left;
        font-weight: var(--weight-regular);
        border-bottom: 1px solid #ccc;
        width: 100%;
        &--active {
            width: 100%;
            text-align: left;
            cursor: pointer;
            padding: 0.3rem;
            border-bottom: 1px solid #ccc;
          span{
            background-color: ${({theme}) => theme.colors.highlight};
          }
            
        }
    }
`;

export default StyledPlacesContainer;